import type { RachelEscapeAction, ResolveRachelEscapeActionParams } from './rachelPanel.types';

export const resolveRachelEscapeAction = ({
  mode,
  isOpen,
  canGoBack,
  isFocusInsidePanel,
}: ResolveRachelEscapeActionParams): RachelEscapeAction => {
  if (mode === 'page') {
    return canGoBack ? 'leavePage' : 'none';
  }

  if (!isOpen) {
    return 'none';
  }

  if (mode === 'overlay') {
    return 'close';
  }

  return mode === 'docked' && isFocusInsidePanel ? 'close' : 'none';
};
